import { Popconfirm } from 'antd';

/**
 * A destructive row action that asks first.
 *
 * The confirmation is Ant Design's `Popconfirm` rather than the template's `#delete-modal`
 * overlay, and the reason is that the template's is a *single* overlay reused by every row — it
 * has no idea which record it was opened for, because in a static template nothing is ever
 * actually deleted. Wiring that up per row means passing the pending record through a global,
 * which is how a confirmation dialog deletes the wrong thing.
 *
 * `Popconfirm` is anchored to the button that opened it, so the record is never in doubt, and it
 * traps focus and closes on Escape without any of that being written here.
 */
export function ConfirmButton({
  icon,
  label,
  title,
  description,
  confirmText,
  disabled = false,
  pending = false,
  onConfirm,
}: {
  icon: string;
  /** Names the record, so a screen reader hears "Delete Rajkot Main" rather than a bare "Delete". */
  label: string;
  title: string;
  description?: string;
  confirmText: string;
  disabled?: boolean;
  pending?: boolean;
  onConfirm: () => void;
}) {
  return (
    <Popconfirm
      title={title}
      description={description}
      okText={confirmText}
      okButtonProps={{ danger: true, loading: pending }}
      cancelText="Cancel"
      disabled={disabled}
      onConfirm={onConfirm}
      placement="leftTop"
    >
      <button
        type="button"
        className="inline-flex size-7 cursor-pointer items-center justify-center rounded-md border border-border-color bg-white text-danger hover:bg-danger-transparent disabled:cursor-not-allowed disabled:opacity-40"
        aria-label={label}
        title={label}
        disabled={disabled}
      >
        <i className={`${icon} text-[13px]`} />
      </button>
    </Popconfirm>
  );
}
